import UserProfileBasedSecurity from "@/interfaces/Security/UserProfileBasedSecurity";
import Vue from "vue";

const END_POINT = "api/customerPortal/v1/userProfileBasedSecurity";

export async function getUserProfileBasedSecurity(): Promise<UserProfileBasedSecurity> {
  const response = await Vue.axios.get(END_POINT);
  return response.data as UserProfileBasedSecurity;
}
